import { useEffect, useCallback, useRef } from 'react';
import { DISABLE_CLICK_CLASS } from 'util/constants';
import { useSceneLoaded } from './useSceneLoaded';

export function useDisableClicksOnSceneLoad() {
  const { sceneFirstFullyLoaded } = useSceneLoaded();
  const emergencyTimeout = 15000;
  const emergencyExit = useRef(null as any);

  const enableEvents = useCallback(() => {
    document.body.classList.remove(DISABLE_CLICK_CLASS);
  }, []);

  useEffect(() => {
    document.body.classList.add(DISABLE_CLICK_CLASS);
    emergencyExit.current = setTimeout(enableEvents, emergencyTimeout);

    return () => {
      clearTimeout(emergencyExit.current);
    };
  }, []);

  useEffect(() => {
    if (sceneFirstFullyLoaded) {
      enableEvents();
      clearTimeout(emergencyExit.current);
    }
  }, [sceneFirstFullyLoaded]);

  return;
}
